window.showLoadingRow = function (elm, cs) {
  var loadingRow = `<tr id="loading-row"><td colspan="${cs}" class="text-center py-1"><div class="spinner-border spinner-border-sm text-primary" role="status"></div></td></tr>`;
  $(`${elm} tbody`).html(loadingRow);
}

window.hideLoadingRow = function () {
  $('#loading-row').remove();
}

window.dtFinalTouch = function (option = null) {
  $('.dt-length').find('label').remove()
  $('.dt-length').find('select').addClass("py-0")
  $('.dt-search').find('label').remove()
  $('.dt-info').addClass("fs-12")
  $('.dt-layout-table').addClass('overflow-auto')
  $('.dataTable').addClass("pt-2")
  $('.dataTable').attr("style", "border-top: 1px solid #E6EAED")

  if ($("#dt-double-date-filter").length) {
    $(".dt-search").addClass("d-flex")
    $("#dt-double-date-filter").removeClass("d-none")
    $(".dt-search").prepend($("#dt-double-date-filter"))
  }
}

import './absence'
import './employment'
import './recruitment'
import './master_data'
import './schedule'
import './calendar'
import './overtime'
import './presence'
import './system'
import './finance'
